module.exports = __webpack_public_path__ + "static/media/02 Generali Ubezpieczenie upraw Karta produktu.26a51d47.pdf";